<div class="embedded-component-icon background-lines">
  <svg width="169" height="117" viewBox="0 0 169 117" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.36">
      <path d="M116.812 96.7929L151.872 101.072L49.6349 4.27919L14.6191 0L116.812 96.7929Z" fill="url(#paint0_linear_4390_9861)"/>
      <path d="M119.444 24.5009L84.3833 20.2217L168.985 100.649V72.1953L119.444 24.5009Z" fill="url(#paint1_linear_4390_9861)"/>
      <path d="M17.8755 47.7148L0 51.3132L65.827 113.796L90.851 116.826L17.8755 47.7148Z" fill="url(#paint2_linear_4390_9861)"/>
      <path d="M0 13.9414V19.4719L76.8894 92.6656L83.6695 93.4988L0 13.9414Z" fill="url(#paint3_linear_4390_9861)"/>
      <path d="M168.985 60.0062V54.4751L129.792 16.4347L122.968 15.6016L168.985 60.0062Z" fill="url(#paint4_linear_4390_9861)"/>
    </g>
    <defs>
      <linearGradient id="paint0_linear_4390_9861" x1="83.5683" y1="0.825897" x2="83.0923" y2="99.9317" gradientUnits="userSpaceOnUse">
        <stop offset="0.0356537" stop-color="white" stop-opacity="0"/>
        <stop offset="0.4992" stop-color="white"/>
        <stop offset="0.5697" stop-color="white" stop-opacity="0.8592"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint1_linear_4390_9861" x1="152.677" y1="120.477" x2="153.153" y2="21.3713" gradientUnits="userSpaceOnUse">
        <stop offset="0.0356537" stop-color="white" stop-opacity="0"/>
        <stop offset="0.4992" stop-color="white"/>
        <stop offset="0.5697" stop-color="white" stop-opacity="0.8592"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint2_linear_4390_9861" x1="41.629" y1="116.243" x2="41.9689" y2="45.4811" gradientUnits="userSpaceOnUse">
        <stop offset="0.0356537" stop-color="white" stop-opacity="0"/>
        <stop offset="0.4992" stop-color="white"/>
        <stop offset="0.5697" stop-color="white" stop-opacity="0.8592"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint3_linear_4390_9861" x1="28.8479" y1="92.7437" x2="29.2922" y2="-3.11626" gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0"/>
        <stop offset="0.4992" stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint4_linear_4390_9861" x1="177.817" y1="16.3409" x2="177.372" y2="112.201" gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0"/>
        <stop offset="0.4992" stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>
</div>
